import React, {Component} from 'react'
import {Control, Errors, actions} from 'react-redux-form'
import {FormGroup, ControlLabel, FormControl} from 'react-bootstrap'
import {validators} from "../../utils/validators"

const errorMessages = {
  required: 'You have to select a voucher'
};

class VoucherSelect extends Component {
  state = {};

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  changeAction = (model, value) => {
    return (dispatch) => {
      dispatch(actions.change(model, value));
      dispatch(actions.resetValidity(model));
    };
  };

  render(){
    const {errorLabel, vouchers, onChange, staffReward} = this.props;
    const validator =  staffReward ? {
      required: validators.required(this.updateErrors, errorLabel)
    } : {};
    return (
      <FormGroup controlId="voucherType">
        <ControlLabel>I would like to reward my staff with the following vouchers...</ControlLabel>
        <Control.select model=".voucher_type_id"
                        componentClass="select"
                        validators={validator}
                        onChange={onChange}
                        component={FormControl}>
                        changeAction={this.changeAction}>
          <option value="" disabled>&lt;none&gt;</option>
          {
            vouchers.map(voucher => {
              return <option key={voucher.id} value={voucher.id}>{voucher.name}</option>
            })
          }
        </Control.select>

        <Errors
          show={{touched: true, focus: false}}
          className="errors"
          model=".voucher_type_id"
          messages={errorMessages}/>
      </FormGroup>
    )
  }
}

VoucherSelect.defaultProps = {
  disabled: false,
  errorLabel: 'error',
};

export default VoucherSelect;



// WEBPACK FOOTER //
// ./src/components/store-summary/voucher-select.jsx